import { createUseStyles } from 'react-jss'
import { bottomDrawerPadding } from '../../../../../styles/common/drawerForms'

const useStyles = createUseStyles({
  editSections: {
    paddingBottom: bottomDrawerPadding
  }
})

export default useStyles
